import React, { ReactNode, RefObject } from 'react';
import ResizeComponent from 'components/ResizeComponent';
import { MinCellWidth } from 'const';
import { AssetAlignment } from 'models';

type ResizeContextType = {
  alignment: AssetAlignment;
  containerRef: RefObject<HTMLDivElement>;
  startResizing?: (currentWidth: number, currentHeight: number) => void;
  finishResizing: (actualWidth: number, actualHeight: number) => void;
  onResize: (newHeight: number) => void;
  width: number;
  height: number;
  minHeight: number;
};

type Props = ResizeContextType & {
  children?: ReactNode;
};

const ResizableButton: React.FC<Props> = (props): JSX.Element => {
  const {
    alignment,
    containerRef,
    startResizing,
    finishResizing,
    onResize,
    width,
    height,
    minHeight,
    children,
  } = props;

  return (
    <ResizeComponent
      alignment={alignment}
      container={containerRef.current ?? undefined}
      startResizing={startResizing}
      finishResizing={finishResizing}
      isResponsive={false}
      onResize={onResize}
      width={width}
      minWidth={MinCellWidth.CTA}
      height={height}
      minHeight={minHeight}
    >
      {children}
    </ResizeComponent>
  );
};

export default ResizableButton;
